module.exports = __webpack_public_path__ + "media/images/favicon-b8c501f3cd975ad2443c0b1797bafef2.ico";